<template>
<div>
    <Modal-Comments :data="aud" @cancel="viewComments" v-if="showModal"/>
    <img src="@/assets/img/icons/comment-alt-regular.svg" style="width: 20px; margin-right: 20px; cursor: pointer" @click="viewComments(true)" title="Ver comentarios" v-if="aud.importance > 0">
    <audio controls class="user_view__audioItem--audio">
        <!-- <source :src="aud.link.url" type="audio/wav" @error="errorAudio"> -->
        <source :src="(aud.link1.url).replace('#', '%23')" type="audio/wav" @error="errorAudio" id="link1" v-if="link1"> 
        <source :src="(aud.link2.url).replace('#', '%23')" type="audio/wav" @error="errorAudio" id="link2" v-if="link2"> 
        <source :src="(aud.link3.url).replace('#', '%23')" type="audio/wav" @error="errorAudio" id="link3" v-if="link3"> 
        <source :src="(aud.link4.url).replace('#', '%23')" type="audio/wav" @error="errorAudio" id="link4" v-if="link4"> 
    </audio>
    <h4 :style="`margin-left:25px;color: ${color}; font-size: 12px;`">Grabado a las {{aud.hour}}</h4>
</div>
</template>
<script>
export default {
    props:{
        aud: Object,
        color: {
            type: String,
            default: 'FC3E3B'
        }
    },
    data() {
        return {
            link1: true,
            link2: true,
            link3: true,
            link4: true,
            showModal: false
        }
    },
    methods: {
        errorAudio(e){
            e.target.id == "link1" ? this.link1 = false : ''
            e.target.id == "link2" ? this.link2 = false : ''
            e.target.id == "link3" ? this.link3 = false : ''
            e.target.id == "link4" ? this.link4 = false : ''
        },
        viewComments(value){
            this.showModal = value;
            console.log('Información', this.aud)
        }
    },
}
</script>


// WEBPACK FOOTER //
// src/components/shared/AudioItem.vue